export default "__VITE_ASSET__DpnxRVuU__"